
import CreateProfileContainer from './CreateProfileContainer';

export default CreateProfileContainer
